<template>
  <div @click="onclick()" class="item button">
    <div class="l">
      <img class="item-icon" :src="src" />
      <span class="item-title">{{ title }}</span>
      <span class="item-title copy" v-if="isCopy" @click="copySuccess(title)">{{ $t('Copy') }}</span>
    </div>
    <span class="iconfont arrow">&#xe650;</span>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  props: {
    isCopy: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    src: {
      type: String
    }
  },
  methods: {
    onclick() {
      this.$emit('onclick')
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t('succ'))
          // console.log(e);
        }, (e) => {
          Toast(this.$t('err'))
          // console.log(e);
        }
      );
    },
  }
}
</script>

<style lang="scss" scoped>
.item {
  padding: .5rem 0;
  text-align: center;
  box-sizing: border-box;
  float: left;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f6f6f6;

  &:last-child {
    border-bottom: none;
  }
}

.l {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.item-icon {
  display: block;
  margin: 0 10px 0 0;
  width: 1.2rem;
  // height: 1rem;
  font-weight: 500;
}

.item-title {
  display: block;
  font-size: $fontSize;
  color: $descTextColor;
  height: 1rem;
  line-height: 1rem;
  // margin-top: 0.3rem;
  white-space: nowrap;
}

.copy {
  color: $primaryColor;
  font-weight: 600;
  margin: 0 .5rem;
  font-size: .5rem;
}

.arrow {
  font-size: .6rem;
  font-weight: 800;
  color: #b4b6bf;
}
</style>
